import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function generateCapsule(payload) {
  const { data } = await http.post("/news/generate", payload);
  return data;
}

export async function getCapsule(id) {
  const { data } = await http.get(`/news/${id}`);
  return data;
}

export function getCapsuleAudioUrl(id) {
  return `${API}/news/${id}/audio`;
}

export async function listRecent(limit = 6) {
  const { data } = await http.get(`/news/recent/list`, { params: { limit } });
  return data;
}

export async function searchNews(q, limit = 20) {
  const { data } = await http.get(`/news/search`, { params: { q, limit } });
  return data;
}

export async function getFeaturedToday() {
  const { data } = await http.get(`/news/featured/today`);
  return data;
}

export async function getVersion() {
  const { data } = await http.get(`/version`);
  return data;
}
